module.exports = __webpack_public_path__ + "img/logo.25f94309.svg";